import { ethers } from 'ethers';
export async function giveBotFeedback(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { agentId, score, tag1, tag2, feedbackUri, feedbackHash, signer } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for giveBotFeedback operation.');
    }
    const tag1Bytes = tag1 ? ethers.utils.formatBytes32String(tag1) : ethers.constants.HashZero;
    const tag2Bytes = tag2 ? ethers.utils.formatBytes32String(tag2) : ethers.constants.HashZero;
    const giveFeedbackCallData = appRegistryDapp.reputation.interface.encodeFunctionData('giveFeedback', [agentId, score, tag1Bytes, tag2Bytes, feedbackUri, feedbackHash]);
    return smartAccount.sendUserOp({
        toAddress: [appRegistryDapp.reputation.address],
        callData: [giveFeedbackCallData],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
